import "./Administracion.css";
import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import { DangerButton, SuccessButton } from "../../ui/buttons/Button.jsx";
import { Input } from "../../ui/inputs/Input.jsx";

export const GestionarBancos = (props) => {
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../src/modulos/datos");

  const txtId = useRef();
  const txtDescripcion = useRef();

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [values, setValues] = useState({
    idbanco: "",
    nombre: "",
  });

  const onChangeValidar = () => {
    let sigue = true;
    if (txtDescripcion.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Ingresar la Descripcion del Banco.",
        icono: "informacion",
      });
      sigue = false;
      txtDescripcion.current.focus();
    } else if (sigue) {
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };
  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/administracion/actualizarbanco`;
    let body;
    body = {
      operacion: operacion,
      nid: values.idbanco !== "" ? values.idbanco : 0,
      nom:
        txtDescripcion.current.value !== ""
          ? txtDescripcion.current.value.trim().toUpperCase()
          : "",
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "agente_rif_key"'
          ) {
            mensaje = "Ya existe un Registro con este rif";
          } else if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "agente_email_key"'
          ) {
            mensaje = "Ya existe un Registro con este correo";
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const blanquear = () => {
    setValues({
      idbanco: "",
      nombre: "",
    });
  };
  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };
  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };
  const cerrarModal = () => {
    props.onHideRenderizar();
    props.onHideCancela();
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setValues(props.bancos);
        }
      }}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>
          {props.operacion === 1
            ? "Agregar Banco."
            : props.operacion === 2
            ? "Editar Banco."
            : props.operacion === 3
            ? "Eliminar Banco."
            : "Consultar Banco."}
        </h3>
        <a type="button" onClick={cancelar}>
          salir<i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        {operacion !== 1 &&
          <div className="col-4 m-0 p-0 mb-2">
            <Input
              label="Codigo:"
              defaultValue={values.idbanco}
              disabled
              ref={txtId}
            />
          </div>
        }
        <div className="col-12 m-0 p-0">
          <Input
            label="Descripción:"
            defaultValue={values.nombre !== null ? values.nombre.trim() : ""}
            disabled={operacion === 1 || operacion === 2 ? false : true}
            name="nombre"
            ref={txtDescripcion}
          />
        </div>
      </Modal.Body>
      <Modal.Footer className="footer-azulGradiant">
        <SuccessButton
          onClick={onChangeValidar}
          disabled={operacion === 4 ? true : false}
        >
          Aceptar
        </SuccessButton>
        <DangerButton onClick={cancelar}>Cancelar</DangerButton>
      </Modal.Footer>

      <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
